export default {
  NEVER: "never",
  ONCE: "once",
  RECURRING: "recurring",
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  YEARLY: "yearly",
};
